import { Input } from "@progress/kendo-react-inputs";

export const ViewEntryColumnWidthProperty = {
  propertyName: "ViewEntryColumnWidth",
  propertyDisplay: "View Entry - Column Width",
  propertyType: "number",
  propertyCategory: "Layout",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type={"number"}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName]}
      />
    );
  },
};
